module.exports = __webpack_public_path__ + "img/cast.04fa531a.svg";